import type { ReactNode } from 'react';
import type { MenuTypeEnum } from '@/api/hanly/hanlyAPI.schemas';
import { useMenuVisibility } from '@/hooks/use-menu-visibility';

type Props = {
  menuType: MenuTypeEnum;
  children: ReactNode;
  fallback?: ReactNode;
};

/**
 * サーバーサイドのメニュー表示制御に基づいて条件付きレンダリングを行うコンポーネント
 *
 * デフォルトは表示。組織ごとに非表示設定(is_hidden=true)されたメニューのみ非表示にする。
 *
 * @example
 * ```tsx
 * <ServerMenuVisibility menuType="PROJECTS">
 *   <NavLink to="/projects">案件</NavLink>
 * </ServerMenuVisibility>
 * ```
 */
export const ServerMenuVisibility = ({ menuType, children, fallback = null }: Props) => {
  const { isVisible } = useMenuVisibility();

  return isVisible(menuType) ? children : fallback;
};
